import styled from '@emotion/styled';

export const EnvBannerContainer = styled.div`
    margin: -20px 0 16px 0;
`;
